import { isDemoModeActive, setDemoMode } from '@/utils/demo-mode';
import { useState } from 'react';
import { useQueryClient } from 'react-query';

export const useDemoMode = () => {
  const queryClient = useQueryClient();
  const [isActive, setIsActive] = useState(() => isDemoModeActive());

  const handleToggle = async (checked: boolean) => {
    setDemoMode(checked);
    setIsActive(checked);

    await new Promise((resolve) => setTimeout(resolve, 0));

    queryClient.resetQueries();
    await queryClient.refetchQueries();
  };

  return { isActive, handleToggle };
};
